import { Flex } from '@mantine/core';
import styled from 'styled-components';
import type { FlexExtendedProps } from './FlexExtended.types';

export const FlexExtended = styled(Flex).withConfig({
	shouldForwardProp: (prop) =>
		![
			'flex',
			'flexGrow',
			'background',
			'border',
			'borderRight',
			'borderLeft',
			'borderTop',
			'borderBottom',
			'borderRadius',
			'verticalScroll',
		].includes(prop),
})<FlexExtendedProps>`
	${(props) => props.flex !== undefined && `flex: ${props.flex};`}
	${(props) => props.flexGrow !== undefined && `flex-grow: ${props.flexGrow};`}
	${(props) => props.background !== undefined && `background: ${props.background};`}
	${(props) => props.border !== undefined && `border: ${props.border};`}
	${(props) => props.borderRight !== undefined && `border-right: ${props.borderRight};`}
	${(props) => props.borderLeft !== undefined && `border-left: ${props.borderLeft};`}
	${(props) => props.borderTop !== undefined && `border-top: ${props.borderTop};`}
	${(props) => props.borderBottom !== undefined && `border-bottom: ${props.borderBottom};`}
	${(props) => props.borderRadius !== undefined && `border-radius: ${props.borderRadius};`}
	${(props) => props.verticalScroll && `overflow-y: auto;`}
`;
